import React, { useEffect, useState } from 'react';

//Material
import { Box, Grid, Modal, TextField, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
// import PersonOffOutlinedIcon from '@mui/icons-material/PersonOffOutlined';
// import styled from '@emotion/styled';
import './PostModal.css';
// import { useTranslate } from 'react-redux-multilingual';
// import { useSnackbar } from 'notistack';
import { StyledLabel } from '../../components/StyledComponents';
// import ApiService from '../../helpers/apiHelper';
import { setIsOpenUserReadersModal } from '../../redux/mainReducer';
import { connect, useDispatch } from 'react-redux';
// import { useSnackbar } from 'notistack';
// import {  encode as btoa, decode as atob } from 'base-64';
// import sha256 from 'crypto-js/sha256';
// import { useNavigate } from 'react-router-dom';
import { useNavigate, useParams } from 'react-router-dom';
import expandIcon from '../../assets/arrowExpand.png';
import { base } from '../../redux/thunk';
import UserListCardReader from '../../components/UserListCardReader';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 700,
  bgcolor: 'background.paper',
  borderRadius: '20px',
  border: 'none',
  boxShadow: 24,
  padding: { xs: '40px 20px', sm: '40px 60px' },
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: 'inherit',
  maxHeight: '100vh',
  minHeight: '11vh'
};

// const CssTextField = styled(TextField)({
//   '& label.Mui-focused': {
//     color: '#000000'
//   },
//   '& label': {
//     color: '#A1A1A1',
//     fontFamily: 'FixelText-Light'
//   },

//   margin: '5px 0px'
// });

function UserReadersModal({ isOpenModal, data, language, userData, nickname }) {
  // const [imgs, setImgs] = useState([]);
  // eslint-disable-next-line
  const [screenType, setScreenType] = useState('desktop');
  const [searchvalue, setSearchValue] = useState('');
  const params = useParams();
  const dispatch = useDispatch();
  // eslint-disable-next-line
  const navigate = useNavigate();
  useEffect(() => {
    if (window.screen.width <= 600) {
      setScreenType('mobile');
    }
  }, []);
  // const translate = useTranslate();
  // const { enqueueSnackbar } = useSnackbar();
  // const api = new ApiService('posts/posts', translate);

  // const apiChats = new ApiService('notification/chats');
  // const apiBU = new ApiService('auth/blocked-users');
  // const apiBU = new ApiService('/blocked-users');
  // const apiChats = new ApiService('chats');
  return (
    <div>
      <Modal
        open={isOpenModal}
        onClose={(event, reason) => {
          if (reason === 'backdropClick') {
            return;
          }
          dispatch(setIsOpenUserReadersModal(false));
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="bonfair_post_modal"
      >
        <Box sx={style} className="bonfair_post_modal-box">
          <CloseIcon
            className="bonfair_post_modal-close"
            style={{
              position: 'absolute',
              right: '10px',
              top: '10px',
              cursor: 'pointer',
              zIndex: '1000'
            }}
            onClick={() => {
              dispatch(setIsOpenUserReadersModal(false));
            }}
          />

          <Grid container spacing={1}>
            <Grid item xs={12} md={12} lg={12}>
              <StyledLabel className="postModal-title-text">
                {/* {translate('bonfair_service_modal')} */}
                Підписники
                {params.id && params.id !== userData?.id ? ` @${nickname}` : ''}
              </StyledLabel>
              {data.length === 0 ? (
                <Typography
                  sx={{ margin: '0 auto', color: '#7C7C7C' }}
                  fontSize={16}
                  textAlign="center"
                >
                  {params.id && params.id !== userData?.id
                    ? 'У цього користувача поки що немає підписників'
                    : 'Поки підписників немає'}
                </Typography>
              ) : (
                <Typography
                  sx={{ margin: '0 auto', color: '#A1A1A1' }}
                  fontSize={16}
                  textAlign="center"
                >
                  {`Кількість: ${data.length}`}
                </Typography>
              )}
            </Grid>
            {params.id === userData.id || !params.id ? (
              <Grid
                item
                xs={12}
                style={{ padding: '0px' }}
                sx={{ mb: 4, mt: 4, justifyContent: 'center', display: 'flex' }}
              >
                {data.length > 10 && (
                  <TextField
                    sx={{
                      input: {
                        fontFamily: 'FixelText-Regular',
                        fontSize: '16px',
                        fontWeight: '350',
                        lineHeight: '19px',
                        letterSpacing: '0em',
                        textAlign: 'left',
                        '&::placeholder': {
                          fontFamily: 'FixelText-Regular',
                          fontSize: '16px',
                          fontWeight: '350',
                          lineHeight: '19px',
                          letterSpacing: '0em',
                          textAlign: 'left'
                          // <----- Add this.
                          // opacity: 1,
                        }
                      }
                    }}
                    placeholder="Кого шукаємо?"
                    variant="standard"
                    fullWidth
                    value={searchvalue}
                    onChange={(e) => setSearchValue(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            width: 'fit-content',
                            cursor: 'pointer'
                          }}
                          // onClick={() => {
                          //   navigate(`/${language}/search?question=${value}`);
                          // }}
                        >
                          <img
                            alt="arrow"
                            src={expandIcon}
                            style={{ width: '35px', margin: '5px' }}
                          />
                        </div>
                      )
                    }}
                    // onKeyDown={(e) => {
                    //   if (e.key === 'Enter') {

                    //     navigate(`/${language}/search?question=${value}`);
                    //   }
                    // }}
                  />
                )}
                {/*{data.length === 0 && (*/}
                {/*  <FreeBtn*/}
                {/*    padding="8px 20px"*/}
                {/*    onClick={() => {*/}
                {/*      dispatch(setIsOpenUserContactsModal(false));*/}
                {/*      navigate(`/${language}/search/users?question=`);*/}
                {/*    }}*/}
                {/*    text="Перейти до пошуку"*/}
                {/*  />*/}
                {/*)}*/}
              </Grid>
            ) : null}
            <Grid
              item
              xs={12}
              sx={{
                maxHeight: '60vh',
                overflowY: 'scroll',
                overflowX: 'hidden'
              }}
            >
              {searchvalue.length !== 0 ? (
                <>
                  {data
                    .filter((user) =>
                      `${user.name}${user.surname}${user.nickname}`.includes(searchvalue)
                    )
                    .map((user, index) => (
                      <React.Fragment key={`userCard${index}`}>
                        <UserListCardReader user={user} index={index} />
                      </React.Fragment>
                    ))}
                </>
              ) : (
                <>
                  {data.map((user, index) => (
                    <React.Fragment key={`userCard${index}`}>
                      <UserListCardReader user={user} index={index} />
                    </React.Fragment>
                  ))}
                </>
              )}
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale,
    isOpenSearchBar: state.global.isOpenSearchBar,
    userData: state.global.userData,
    blockedUsers: state.global.blockedUsers
  };
};
export default connect(mapStateToProps, {
  getBlockedUsersThunk: base.getBlockedUsersThunk,
  getUserSubscribersThunk: base.getUserSubscribersThunk,
  getUserSubscriptionsThunk: base.getUserSubscriptionsThunk
})(UserReadersModal);
